<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 10:46:28
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-10-30 16:38:41
 * @FilePath: /wemeet-admin-new/src/views/aiProduct/components/editAiSentence.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <el-drawer
    ref="drawerRef"
    v-model="dialogFormVisible"
    :before-close="handleClose"
    custom-class="demo-drawer"
    :direction="direction"
    :size="size"
    :title="title"
  >
    <div v-if="list.length > 0" class="demo-drawer__footer">
      <el-button type="primary" @click="handleSave()">保存</el-button>
    </div>
    <el-descriptions border :column="1" direction="vertical" :size="desSize">
      <el-descriptions-item
        v-for="(item, index) in list"
        v-if="list.length > 0"
        :key="index"
        :label="'金句' + (index + 1)"
      >
        <div class="alignItem">
          <div style="min-width: 80px">是否显示</div>
          <el-switch v-model="item.isShow" active-text="显示" inactive-text="隐藏" size="large" />
        </div>
        <div class="alignItem">
          <div style="min-width: 80px">标题</div>
          <el-input v-model="item.title" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="" type="textarea" />
        </div>

        <div class="alignItem">
          <div style="min-width: 80px">正文</div>
          <el-input v-model="item.text" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="" type="textarea" />
        </div>

        <div class="alignItem">
          <div style="min-width: 80px">原文</div>
          <el-input v-model="item.metaTxt" :autosize="{ minRows: 2, maxRows: 4 }" placeholder="" type="textarea" />
        </div>
      </el-descriptions-item>

      <el-descriptions-item v-else>
        <el-empty class="vab-data-empty" description="暂无数据" />
      </el-descriptions-item>
    </el-descriptions>

    <el-pagination
      background
      :current-page="queryForm.pageNum"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
  </el-drawer>
</template>
<script>
  import { defineComponent, getCurrentInstance, onMounted, reactive, ref, toRefs } from 'vue'
  import { baseH5URL } from '@/config'
  import { abstractSentenceGetList, updateSentence } from '@/api/ai'
  export default defineComponent({
    name: 'GenerateWx',
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance()
      const state = reactive({
        dialogFormVisible: false,
        direction: 'rtl',
        size: '40%',
        title: '链接地址',
        loading: null,
        row: {},
        registerMobileUrl: [],
        title: '编辑AI金句',
        queryForm: {
          pageSize: 10,
          pageNum: 1,
          scheduleCode: '',
        },
        list: [],
        total: 0,
      })
      // 打开
      const handleOpen = (row = {}) => {
        state.row = row
        state.queryForm.scheduleCode = row.scheduleCode
        getList()
        state.dialogFormVisible = true
      }
      // 关闭
      const handleClose = () => {
        state.dialogFormVisible = false
      }

      const getList = async () => {
        const { data } = await abstractSentenceGetList(state.queryForm)
        state.list = data.data
        state.total = data.total
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        getList()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        getList()
      }

      const handleSave = async () => {
        try {
          const { data } = await updateSentence({ params: state.list })
          proxy.$baseMessage(`操作成功`, 'success', `vab-hey-message-success`)
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
        }

        handleClose()
      }

      return {
        ...toRefs(state),
        handleOpen,
        handleClose,
        handleSizeChange,
        handleCurrentChange,
        handleSave,
      }
    },
  })
</script>

<style lang="scss" scoped>
  .vab-tree-border {
    height: 200px;
    padding: $base-padding;
    overflow-y: auto;
    border: 1px solid #dcdfe6;
    border-radius: $base-border-radius;
  }

  .el-descriptions {
    height: 80vh;
    overflow: auto;
  }
  .demo-drawer__content {
    height: 85vh;
    overflow: auto;
  }
  .containerForm {
    height: 85vh;
    overflow-y: auto;
  }
  .demo-drawer__footer {
    margin-bottom: 5px;
  }

  .alignItem {
    display: flex;
    margin-bottom: 10px;
  }
</style>
